import { gql, useQuery } from "@apollo/client";
import React, { createContext, PropsWithChildren, useContext, useMemo, useState } from "react";
import { ContextUser } from "src/context/ContextUser";
const PolariIcon = require("@shopify/polaris-icons");

const QUERY = gql`
  query sellerMenu {
    sellerMenu
  }
`;

function formatUrl(url: string) {
  if (url.charAt(0) !== "/") {
    return "/" + url;
  }
  return url;
}

const SellerMenuContext = createContext<{
  MenuShopify: any[];
  setMenuShopify: any;
}>({
  MenuShopify: [
    {
      name: "Loading Menu...",
      to: "#",
      header: true,
      id: "dashbord",
      count: 0,
    },
  ],
  setMenuShopify: (v: any) => {},
});

export function useSellerMenu() {
  return useContext(SellerMenuContext);
}

export function SellerMenuProvider(props: PropsWithChildren<unknown>) {
  const { merchant } = useContext(ContextUser);
  const [MenuShopify, setMenuShopify] = useState([
    {
      name: "Loading Menu...",
      to: "#",
      header: true,
      id: "dashbord",
      count: 0,
    },
  ]);

  useQuery(QUERY, {
    skip: MenuShopify.length > 1,
    onCompleted: (data) => {
      if (data.sellerMenu) {
        const obj = Object.keys(data.sellerMenu)
          .filter((x) => x !== "dashboard")
          .map((x) => {
            const arr = [
              {
                name: data.sellerMenu[x].name,
                id: x,
                to: "#",
                header: true,
              },
              ...data.sellerMenu[x].menu.map((m: any) => {
                return {
                  name: m.name,
                  icon: PolariIcon[m.icon],
                  id: x,
                  to: formatUrl(m.defaultMenu.to),
                  subs:
                    m.subMenu.length > 1
                      ? m.subMenu.map((s: any) => {
                          return {
                            ...s,
                            to: formatUrl(s.to),
                            count: ["Remoted Orders"].includes(s.name) ? merchant.orderCount : 0,
                          };
                        })
                      : null,
                  count: ["Customer Orders"].includes(m.name) ? merchant.orderCount : 0,
                };
              }),
            ];
            return arr;
          })
          .flat();
        setMenuShopify(obj);
      }
    },
  });

  return (
    <SellerMenuContext.Provider
      value={useMemo(() => {
        return {
          MenuShopify,
          setMenuShopify,
        };
      }, [MenuShopify, setMenuShopify])}
    >
      {props.children}
    </SellerMenuContext.Provider>
  );
}
